<!--
 * @Description: 
 * @Author: 山淑兰
 * @Date: 2019-09-10 10:05:16
 * @LastEditTime: 2020-07-15 17:45:36
 * @LastEditors: 山淑兰
 -->
<template>
  <div id="app">
    <transition name="fade">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style>
#app {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, #eef2f7 0%, #f5f7fc 40%, #e8edf5 100%);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif;
  position: relative;
  box-sizing: border-box;
  color: #1e293b;
}
.van-toast {
  width: auto !important;
  font-size: 28px !important;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  /* transform: translateX(200%) */
}
.fade-enter-to,
.fade-leave {
  opacity: 1;
  /* transform: translateX(0%) */
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1s;
}
</style>
